const translations = {
  "en": {
    "On your own": "On your own",
    "With Ed": "With Ed"
  },
  "zh-tw": {
    "On your own": "自行操作",
    "With Ed": "由 Ed 協助"
  }
};

export default translations;
